// @flow
import type { LocalizedFormatFunction, StrictStringMap } from '@rover/react-lib/types';

const generateExternalFormatMap = (
  getLocalizedFormat: LocalizedFormatFunction,
  language: ?string
): StrictStringMap => ({
  'M/DD': getLocalizedFormat('MONTH_DAY_SHORT', language),
});

export default generateExternalFormatMap;



// WEBPACK FOOTER //
// ../shared/js/constants/i18n/datetime/generateExternalFormatMap.js